import React, { useRef } from "react";
import { bool, func, array } from "prop-types";
import { useTranslation } from "@lib/i18n";

import { Button } from "@components/shared/Button";
import Typography from "@components/shared/Typography";
import RequestButton from "@components/shared/RequestButton";
import Modal from "@components/shared/Modal";

const UnavailableItemsModal = ({
  isOpen,
  unavailableItems,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  return (
    <Modal
      ariaLabel={t("preconfiguration.heading")}
      firstElement={modalFirstElement}
      isOpen={isOpen}
      lastElement={modalLastElement}
      onClose={onCancel}
    >
      <div
        className="flex flex-col items-center h-full gap-8 py-4 text-center"
        data-id={"unavailable-items-modal-container"}
      >
        <h4 className="text-xl font-semibold">
          {t("preconfiguration.heading")}
        </h4>
        <Typography>{t("basket.errorMessages.optionsUnavailable")}</Typography>
        {!!unavailableItems?.length && (
          <Typography>
            {unavailableItems.map(item => item.label).join(", ")}
          </Typography>
        )}
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          <RequestButton
            data-id={"unavailable-items-modal-change-confirm-btn"}
            ref={modalFirstElement}
            triggerRequestCallback={onConfirm}
          >
            {t("general.accept")}
          </RequestButton>
          <Button
            data-id={"unavailable-items-modal-change-cancel-btn"}
            onClick={onCancel}
            ref={modalLastElement}
            variant="secondary"
          >
            {t("general.cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

UnavailableItemsModal.propTypes = {
  isOpen: bool.isRequired,
  unavailableItems: array.isRequired,
  onConfirm: func.isRequired,
  onCancel: func.isRequired,
};

export default UnavailableItemsModal;
